import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";

# راهنمای مدیریت علل توقف (Downtime Reasons)

این بخش به شما اجازه می‌دهد کدهای استانداردی برای توقفات دستگاه‌ها و خطوط تولید تعریف کنید تا پرسنل در زمان ثبت توقف، مجبور به تایپ دستی نباشند و گزارش‌گیری دقیق‌تری امکان‌پذیر شود.

## چرا کدهای توقف مهم هستند؟
داشتن کدهای استاندارد (مانند `M-01` برای خرابی مکانیکی یا `E-02` برای قطعی برق) به شما کمک می‌کند تا در پایان ماه متوجه شوید بیشترین زمان توقف به چه علتی رخ داده است و برای رفع ریشه‌ای آن برنامه‌ریزی کنید.

## نحوه تعریف علت جدید
۱. روی دکمه **➕ تعریف علت جدید** کلیک کنید.
۲. **کد توقف**: یک شناسه کوتاه و یکتا وارد کنید (مثلاً `MAT-01` برای کمبود مواد اولیه).
۳. **عنوان / شرح توقف**: توضیح مختصری از علت توقف را بنویسید (مثلاً `تأخیر در رسیدن مواد اولیه به خط`).
۴. روی دکمه **ذخیره** کلیک کنید. 

به محض ذخیره، این علت توقف در منوی کشویی فرم «ثبت توقف تولید جدید» در داشبورد توقفات قابل انتخاب خواهد بود.

## حذف یک علت توقف
- با کلیک روی دکمه **حذف** در مقابل هر رکورد، می‌توانید آن را از سیستم پاک کنید.
- **توجه:** در صورتی که یک علت توقف قبلاً در رکوردهای توقف ماشین‌آلات استفاده شده باشد، به دلیل حفظ تاریخچه، امکان حذف آن وجود نخواهد داشت.

export default Layout;
